import React from "react";
import styled from "styled-components";
import { Box } from "@mui/material";
import { CheckCircleOutline as CheckIcon } from "@mui/icons-material";

const Wrapper = styled(Box)`
  background-color: ${(props) => props.color};
  width: 30px;
  height: 30px;
  border-radius: 30px;
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
`;
const CustomCheckIcon = styled(CheckIcon)`
  color: rgba(47, 47, 47, 0.5);
  font-size: 25px !important;
`;

const ColorButton = (props) => {
  const { color, active, onClick } = props;

  return (
    <Wrapper color={color} onClick={onClick}>
      {active ? <CustomCheckIcon /> : <></>}
    </Wrapper>
  );
};

export default ColorButton;
